import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ProfileService, ProfileServiceError } from "../services/profileService";
import { UserProfile } from "../types/user";
import { ProfileError } from "./useProfile";

export const useSharedProfile = (userId?: string, context: 'profile' | 'messaging' = 'profile') => {
    const queryClient = useQueryClient();
  
    return useQuery<UserProfile, ProfileError>({
      queryKey: ["profile", userId, context],
      queryFn: async () => {
        
        if (!userId) {
          console.log('No userId provided');
          throw new ProfileServiceError(
            "No profile ID available",
            "PROFILE_NOT_FOUND"
          );
        }
  
        // Always fetch fresh data from Firestore
        const profile = await ProfileService.getProfile(userId);
        
        // Update all related queries in the cache with the full profile data
        queryClient.setQueriesData(
          { queryKey: ["profile", userId] }, 
          (oldData: UserProfile | undefined) => ({
            ...oldData,
            ...profile,
          })
        );
        
        return profile;
      },
      // Adjust these options to ensure data consistency
      staleTime: 0,
      gcTime: 1000 * 60 * 5,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    });
  };